export default function Deliverables() {
  const deliverables = ["Comprehensive project documentation, including technical specifications, architecture diagrams, and user manuals.", "Fully functional and rigorously tested source code repository with complete commit history and documentation.", "Deployed staging environment configured for final review, quality assurance, and user acceptance testing.", "Complete set of design assets, including original source files, exported icons, and comprehensive brand guidelines.", "Detailed post-launch support and maintenance plan outlining service level agreements (SLAs) and contact procedures."];
  return <section id="deliverables" className="bg-background text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold tracking-tight mb-4">
          Project Deliverables
        </h2>
        <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
          Upon successful completion of the engagement, you will receive the following key assets and documentation tailored to your specific project requirements:
        </p>
        
        <ol className="list-decimal list-outside ml-6 space-y-5 text-base md:text-lg text-foreground">
          {deliverables.map((item, i) => <li key={i} data-index={i} className="pl-2 leading-relaxed">
              {item}
            </li>)}
        </ol>
      </div>
    </section>;
}